export default function noop() {
  /* empty */
}
